module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/42428924171999cebe3efd5e70b7bc53.svg";